<template>
  <div class="theme-source" :class="dynamicClass" v-if="theme">
    <VisibleText>Source:</VisibleText>
    <div class="theme-source__content">
      <div v-if="!theme.source">
        <SvgIconDecorative style="margin-top: -0.4rem" icon="add" />
        <VisibleText>Manually created</VisibleText>
      </div>
      <div v-if="theme.source">
        <!-- LDA -->
        <div v-if="theme.source.type === 'lda'">
          <SvgIconDecorative style="margin-top: -0.4rem" icon="statisticsGraph" />
          <VisibleText>Keyword topic</VisibleText> -
          <a href="https://en.wikipedia.org/wiki/Latent_Dirichlet_allocation" target="_blank">
            LDA
            <SvgIconDecorative
              icon="externalLink"
              style="margin-left: -0.5rem; margin-top: -0.4rem"
            />
          </a>
        </div>

        <!-- LSI -->
        <div v-if="theme.source.type === 'lsi'">
          <SvgIconDecorative style="margin-top: -0.4rem" icon="statisticsGraph" />
          <VisibleText>Keyword topic</VisibleText> -
          <a
            href="https://en.wikipedia.org/wiki/Latent_semantic_analysis#Latent_semantic_indexing"
            target="_blank"
          >
            LSI
            <SvgIconDecorative
              icon="externalLink"
              style="margin-left: -0.5rem; margin-top: -0.4rem"
            />
          </a>
        </div>

        <!-- BERT -->
        <div v-if="theme.source.type === 'bert'">
          <SvgIconDecorative style="margin-top: -0.4rem" icon="brain" />
          <VisibleText>GenAI topic</VisibleText>
        </div>

        <!-- CTM (original CTM origin) -->
        <div v-if="theme.source.type === 'ctm'">
          <SvgIconDecorative style="margin-top: -0.4rem" icon="customWrench" />
          <VisibleText>Custom model</VisibleText> -
          <router-link
            :to="'/custom-text-model/' + theme.source.origin.topic_model_group_id"
            target="_blank"
          >
            {{ theme.source.origin.topic_model_group_name }}
            <SvgIconDecorative
              icon="externalLink"
              style="margin-left: -0.5rem; margin-top: -0.4rem"
            />
          </router-link>
        </div>

        <!-- Manually linked CTM -->
        <div v-if="theme.source.link?.manually_linked_group_id">
          <SvgIconDecorative style="margin-top: -0.4rem" icon="customWrench" />
          <VisibleText>Linked model</VisibleText> -
          <router-link
            :to="'/custom-text-model/' + theme.source.link.manually_linked_group_id"
            target="_blank"
          >
            {{ theme.source.link.manually_linked_theme_name }}
            <SvgIconDecorative
              icon="externalLink"
              style="margin-left: -0.5rem; margin-top: -0.4rem"
            />
          </router-link>
        </div>

        <!-- Raw search -->
        <div v-if="theme.source.type === 'raw_search'">
          <SvgIconDecorative style="margin-top: -0.4rem" icon="search" />
          <VisibleText>Raw search theme</VisibleText>
        </div>

        <!-- Manual -->
        <div v-if="theme.source.type === 'manual'">
          <SvgIconDecorative style="margin-top: -0.4rem" icon="add" />
          <VisibleText>Manually created</VisibleText>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIconDecorative from '@/components/UI/Svg/SvgIconDecorative.vue';

export default {
  name: 'ThemeSource',
  props: {
    theme: {
      type: Object,
      default: () => {},
    },
    parent: {
      type: String,
      default: () => '',
    },
  },
  components: {
    SvgIconDecorative,
  },
  computed: {
    dynamicClass() {
      if (this.parent === 'generated') {
        return 'theme-source--darken';
      } else {
        return '';
      }
    },
  },
};
</script>
